<template>
  <div class="product-preview">
    <div class="character-setting">{{ $t('home.ProductPreview.categoryDressup') }}</div>
    <div ref="hiddenContainer"
         class="hidden"></div>
    <div v-if="customPreview && hiddenContainer"
         class="viewer">
      <ImageCustomizeViewer v-if="productsItem?.customizedImages[0] && productsItem?.customizedImages[0].customableImage && productsItem?.customizedImages[0].customableImage.custom_areas"
                            :id="productsItem?.customizedImages[0].customableImage.id + ''"
                            :key="productsItem?.customizedImages[0].customableImage.id + ''"
                            :ref="(el: any) => (mirrorStore.productFabric = el)"
                            mode="view"
                            :container="hiddenContainer"
                            :template-basic-parameters="templateBasicParameters(renderImageBaseUrl(productsItem), color(productsItem as any)?.value, productsItem.customizedImages[0].customableImage.width, productsItem.customizedImages[0].customableImage.height)"
                            :custom-area="assignCustomizedData((productsItem as any).customizedImages[0].customableImage.custom_areas, productsItem.customizedImages[0].customableImage.width, (productsItem as any).customizedImages[0].customized_areas.customable_image_scale, (productsItem as any).customizedImages[0].customized_areas.boundingRect)"
                            :customized-image="renderImageCustomUrl(productsItem as any)" />
    </div>
    <div v-else
         class="imageBox">
      <img v-if="mirrorStore.previewClothing"
           :src="mirrorStore.previewClothing" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMirrorStore } from '../../../index'
import { findCustomableImage, templateBasicParameters } from '../../../utils'
import { ImageCustomizeEditor as ImageCustomizeViewer } from "@iota-cn/ui-components"
import { toUrl } from '@iota-cn/ui-scaffolding/src/utils'
import { computed, ref, watch } from 'vue'

const mirrorStore = useMirrorStore()
const customPreview = ref<boolean>(false)
const productsItem = ref<any>()
const hiddenContainer = ref()

watch(() => mirrorStore.previewClothing, async (newPreview) => {
  if (typeof newPreview === 'string') {
    customPreview.value = false
  } else {
    customPreview.value = true
    productsItem.value = newPreview
  }
})

const renderImageBaseUrl = (record: any) => {
  const baseCustomUrl = toUrl(findCustomableImage(color(record), record.customizedImages[0].customableImage))
  const baseHeightRatio = Math.round(record.customizedImages[0].customableImage.custom_areas.bgHeight * (200 / record.customizedImages[0].customableImage.width))
  return baseCustomUrl + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

// 默认颜色
const color = (customSpu: any) => {
  const customSku = customSpu.customSkus[0] || null
  const color =
    customSku?.sku.attrs.filter((el: any) => {
      return el.attribute.key === "color"
    }) || null
  const value = color ? color[0].object_value : null
  return value
}

const assignCustomizedData = computed(() => (custom_areas: any, bgWidth: number, customable_image_scale: number, boundingRect: any) => {
  return Object.assign({},
    { ...(custom_areas || {}) },
    { scale: (200 / bgWidth) * (customable_image_scale || custom_areas.scale) },
    boundingRect || {})
})

const renderImageCustomUrl = (record: any) => {
  const scaleRatio = record.customizedImages[0].customized_areas.customable_image_scale || record.customizedImages[0].customableImage.custom_areas.scale
  // const heightRatio = Math.round((record.customizedImages[0].customized_areas.boundingRect?.height || record.customizedImages[0].customableImage.custom_areas.height) * ((200 / record.customizedImages[0].customableImage.width) * scaleRatio))
  const widthRatio = Math.round((record.customizedImages[0].customized_areas.boundingRect?.width || record.customizedImages[0].customableImage.custom_areas.width) * ((200 / record.customizedImages[0].customableImage.width) * scaleRatio))
  const renderCustomUrl = toUrl(record.customizedImages[0].customized_image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`
  return renderCustomUrl
}
</script>


<style scoped lang="less">
.product-preview {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  position: relative;

  .imageBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #D5E5E6;
    width: 100%;
    height: 100%;

    img {
      width: 220px;
      height: 220px;
    }
  }

}

.character-setting {
  position: absolute;
  z-index: 300;
  top: 8px;
  left: 8px;
  width: 120px;
  height: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #0F171C;
  line-height: 36px;
  background-color: #5FCDD0;
  clip-path: polygon(0 0, 100% 0, 80% 100%, 0% 100%);
  padding-left: 16px;
}

.hidden {
  width: 300px;
  height: 500px;
  position: absolute;
  visibility: hidden;
  z-index: 1;
  display: block;
  object-fit: cover;
  background-size: 100% 100%;
}

.viewer {
  width: 100%;
  height: 500px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @-moz-document url-prefix() {
    :deep(.fabric-div) {
      width: 80px !important;
      height: 80px !important;
    }

    :deep(.canvas-container) {
      width: 80px !important;
      height: 80px !important;
    }

    :deep(.lower-canvas) {
      width: 80px !important;
      height: 80px !important;
    }

    :deep(.upper-canvas) {
      width: 80px !important;
      height: 80px !important;
    }
  }
}
</style>
